// redux/actions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';

const access_token = process.env.REACT_APP_GET_PLAYER_TOKEN;
const REACT_APP_STRAPI_URL = process.env.REACT_APP_STRAPI_URL;


const fetchConfig = async (data: { brand: string; lang: string }, pageType: string) => {
    let response = null;

    if (pageType == "call") {
        response = await fetch(
            `${REACT_APP_STRAPI_URL}/web-rtc-configs?locale=${data.lang}&populate=deep,3&filters[Template][Brand][$eq]=${data.brand}`
        );
    } else {
        response = await fetch(
            `${REACT_APP_STRAPI_URL}/${pageType}-pages?locale=${data.lang}&populate=deep,3&filters[Template][Brand][$eq]=${data.brand}`
        );
    }
    if (!response.ok) {
        throw new Error('Failed to fetch config');
    }
    return response.json();
};

export const pullConfig = createAsyncThunk(
    'config/pullConfig',
    async ({ data, pageType }: { data: { brand: string; lang: string }; pageType: string }, { rejectWithValue }) => {
        try {
            const configData = await fetchConfig(data, pageType);
            const data_j = configData.data;

            if (!data_j || data_j.length === 0) {
                return null;
            }
            return configData;
        } catch (error) {
            // Use type guard to check if `error` has a `message` property
            if (error instanceof Error) {
                return null;
            }
            return null;
        }
    }
);

const ftv_access_token = 'a7ab5e8ebca2dd0564627c5c0295b44ba165f8ea0c7f6c7dc2346e4ecd381dea7fa804c94885cfd4df94080e620e7d4d4943e147a6e2afaef28b2b81c80d541b2dc588d0c6d5d4265abc5b22351df5569461cda81b0827dd0d0d55e5fb0152a34ae64ba5a0483a7300f37edcee4c4f9daf6fe2c35aaec2c03bcfa22bdabe8e53'

// Function to fetch players data based on the "s" value
const fetchPlayers = async (s: string) => {
    const response = await fetch(`${REACT_APP_STRAPI_URL}/players/${s}`, {
        headers: {
            'Authorization': `bearer ${access_token}`
        }
    });
    if (!response.ok) {
        throw new Error('Failed to fetch player data');
    }
    return response.json();
};

// Thunk for pulling players data
export const pullPlayers = createAsyncThunk(
    'players/pullPlayers',
    async (s: string) => {
        return await fetchPlayers(s);
    }
);
